import type { Locale } from '../locales'
import { en, type MessageKey, type Messages } from './en'
import { ja } from './ja'
import { zhHant } from './zh-Hant'

export const catalogs: Record<Locale, Messages> = {
  en,
  ja,
  'zh-Hant': zhHant,
}

export type { MessageKey, Messages }
export { en, ja, zhHant }

export type TranslateVars = Record<string, string | number>

export function translate(
  locale: Locale,
  key: MessageKey,
  vars?: TranslateVars,
): string {
  const template = catalogs[locale][key] ?? catalogs.en[key] ?? key
  if (!vars) return template
  return template.replace(/\{(\w+)\}/g, (_, name: string) => {
    const value = vars[name]
    return value === undefined ? `{${name}}` : String(value)
  })
}
